import { Container } from '@swordhealth/ui-corporate';
import Section from '@/components/ui/Section';
import { SPACE_DESKTOP, SPACE_TABLET, SPACE_MOBILE } from '@/components/ui/Section';
import styled, { css } from 'styled-components';
import { PrettySectionClipPath } from '@/components/ui/Section/PrettySection';

export const LogosContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 44px;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 10;

  & .hero-logos {
    margin-bottom: 0;
    position: relative;
    z-index: 2;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    padding-top: 0;
    position: relative;
  }
`;

export const WrappedContainer = styled(Container)`
  overflow: hidden;
  padding-right: 16px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    padding-top: 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_sm}px) {
    padding-top: 24px;
  }
`;

export const WrappedSection = styled(Section)`
  overflow: hidden;
  padding-bottom: 0;

  ${PrettySectionClipPath};

  ${({ spaceBottom }) =>
    !!spaceBottom &&
    css`
      padding-bottom: ${SPACE_DESKTOP};

      @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
        padding-bottom: ${SPACE_TABLET};
      }

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        padding-bottom: ${SPACE_MOBILE};
      }
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    clip-path: none;
  }
`;

export const Wrapper = styled.div`
  padding-top: 0;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    padding-top: 0;
  }
`;

export const Overlay = styled.div`
  background: linear-gradient(0deg, #5993ea 0%, #ffb4b5 100%);
  height: 100%;
  left: 0;
  mix-blend-mode: multiply;
  opacity: 0.4;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 546px;
  overflow: visible;
  padding-bottom: 216px;
  padding-top: 216px;
  width: 50%;
  z-index: 5;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    align-items: center;
    gap: 16px;
    margin: 0 auto;
    max-width: unset;
    padding: 64px 40px 16px;
    text-align: center;
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_sm}px) {
    padding: 40px 24px 12px;
  }
`;

export const VideoContainer = styled.video`
  height: 100%;
  max-width: 40vw;
  object-fit: cover;
  overflow: visible;
  pointer-events: none;
  position: relative;
  width: 100%;
  max-width: 50%;

  @media (max-width: ${({ theme }) => theme.breakpoints.min_lg}px) {
    aspect-ratio: 9/16;
    justify-self: center;
    max-height: 432px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.min_md}px) {
    aspect-ratio: 9/16;
    max-height: 300px;
    max-width: 100%;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.min_lg}px) {
    align-items: center;
    flex-direction: column;
    gap: 0;
  }
`;

export const ButtonLine = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Subtitle = styled.p`
  align-content: center;
  font-size: 16px;
  line-height: 28px;
`;

export const UpperLabel = styled.p`
  background-clip: text;
  background-image: linear-gradient(90deg, #f87475 0%, #5993ea 68.1%);
  color: transparent;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 16px;
  text-transform: uppercase;
`;

export const ExtraLabel = styled(Subtitle)`
  color: #747986;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  max-width: 280px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    max-width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 32px;
  row-gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    flex-direction: column;
    gap: 12px;
  }
`;
